/**
 * @flow
 * @relayHash 82300c4f68bd4539dc7d27f5e630db01
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type DetailsContent_deliverable$ref = any;
type DetailsDescription_deliverable$ref = any;
type DetailsInfo_deliverable$ref = any;
type DetailsInfo_deliverableStateTypes$ref = any;
type DetailsMainSection_deliverable$ref = any;
type DetailsNotes_deliverable$ref = any;
type DetailsSolicitations_deliverable$ref = any;
type DetailsSolicitations_solicitationStateTypes$ref = any;
export type DeliverableDetailsTabQueryVariables = {|
  id: string
|};
export type DeliverableDetailsTabQueryResponse = {|
  +deliverable: ?{|
    +$fragmentRefs: DetailsInfo_deliverable$ref & DetailsContent_deliverable$ref & DetailsDescription_deliverable$ref & DetailsNotes_deliverable$ref & DetailsSolicitations_deliverable$ref & DetailsMainSection_deliverable$ref
  |},
  +deliverableStateTypes: ?{|
    +$fragmentRefs: DetailsInfo_deliverableStateTypes$ref
  |},
  +solicitationState: ?{|
    +$fragmentRefs: DetailsSolicitations_solicitationStateTypes$ref
  |},
|};
export type DeliverableDetailsTabQuery = {|
  variables: DeliverableDetailsTabQueryVariables,
  response: DeliverableDetailsTabQueryResponse,
|};
*/


/*
query DeliverableDetailsTabQuery(
  $id: ID!
) {
  deliverable(id: $id) {
    ...DetailsInfo_deliverable
    ...DetailsContent_deliverable
    ...DetailsDescription_deliverable
    ...DetailsNotes_deliverable
    ...DetailsSolicitations_deliverable
    ...DetailsMainSection_deliverable
    id
  }
  deliverableStateTypes: __type(name: "DeliverableState") {
    ...DetailsInfo_deliverableStateTypes
  }
  solicitationState: __type(name: "SolicitationState") {
    ...DetailsSolicitations_solicitationStateTypes
  }
}

fragment DetailsInfo_deliverable on DeliverableNode {
  state
  title
  jobId
  contractSignDeadline
  release {
    id
    name
    code
    product {
      id
      title
    }
  }
  job {
    id
    name
  }
}

fragment DetailsContent_deliverable on DeliverableNode {
  id
  title
  description
  state
  internalId
  release {
    id
    name
  }
  category {
    id
    name
    categoryTypes {
      edges {
        node {
          id
          name
        }
      }
    }
  }
  categoryType {
    id
    name
  }
  amount
  currencyCode
  assignedStaff {
    id
    fullName
    user {
      id
    }
  }
  assignedContractor {
    fullName
    id
  }
  assignedInternally {
    fullName
    id
  }
  tags {
    edges {
      node {
        id
        name
      }
    }
  }
  dueDate
  managerNote
}

fragment DetailsDescription_deliverable on DeliverableNode {
  description
  state
}

fragment DetailsNotes_deliverable on DeliverableNode {
  managerNote
}

fragment DetailsSolicitations_deliverable on DeliverableNode {
  solicitations {
    edges {
      node {
        id
        staffCoordinator {
          representativeImageUrl
          fullName
          id
        }
        dateSent
        state
        subject
      }
    }
  }
}

fragment DetailsMainSection_deliverable on DeliverableNode {
  id
  dueDate
  internalId
  state
  category {
    id
    name
  }
  categoryType {
    id
    name
  }
  amount
  currencyCode
  amountInHomeCurrency
  assignedStaff {
    fullName
    representativeImageUrl
    id
  }
  assignedInternally {
    fullName
    representativeImageUrl
    id
  }
  assignedContractor {
    id
    fullName
    representativeImageUrl
  }
}

fragment DetailsInfo_deliverableStateTypes on __Type {
  enumValues {
    name
    description
  }
}

fragment DetailsSolicitations_solicitationStateTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "DeliverableState"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "SolicitationState"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v8 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v12 = [
  (v10/*: any*/),
  (v6/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "enumValues",
    "storageKey": null,
    "args": null,
    "concreteType": "__EnumValue",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      (v9/*: any*/)
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeliverableDetailsTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DetailsInfo_deliverable",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsContent_deliverable",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsDescription_deliverable",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsNotes_deliverable",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsSolicitations_deliverable",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DetailsMainSection_deliverable",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "deliverableStateTypes",
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DetailsInfo_deliverableStateTypes",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "solicitationState",
        "name": "__type",
        "storageKey": "__type(name:\"SolicitationState\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "DetailsSolicitations_solicitationStateTypes",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeliverableDetailsTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeliverableNode",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "jobId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "contractSignDeadline",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "release",
            "storageKey": null,
            "args": null,
            "concreteType": "ReleaseNode",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "product",
                "storageKey": null,
                "args": null,
                "concreteType": "ProductNode",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "JobNode",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          (v6/*: any*/),
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "internalId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryNode",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categoryTypes",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryTypeNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CategoryTypeNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryTypeNode",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categoryType",
            "storageKey": null,
            "args": null,
            "concreteType": "CategoryTypeNode",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currencyCode",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedStaff",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "UserNode",
                "plural": false,
                "selections": [
                  (v6/*: any*/)
                ]
              },
              (v11/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedContractor",
            "storageKey": null,
            "args": null,
            "concreteType": "ContractorNode",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "assignedInternally",
            "storageKey": null,
            "args": null,
            "concreteType": "StaffNode",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tags",
            "storageKey": null,
            "args": null,
            "concreteType": "TagNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TagNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TagNode",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dueDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "managerNote",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "solicitations",
            "storageKey": null,
            "args": null,
            "concreteType": "SolicitationNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "SolicitationNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SolicitationNode",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "staffCoordinator",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/),
                          (v6/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dateSent",
                        "args": null,
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subject",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amountInHomeCurrency",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": "deliverableStateTypes",
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v13/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": "solicitationState",
        "name": "__type",
        "storageKey": "__type(name:\"SolicitationState\")",
        "args": (v3/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": (v13/*: any*/)
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DeliverableDetailsTabQuery",
    "id": null,
    "text": "query DeliverableDetailsTabQuery(\n  $id: ID!\n) {\n  deliverable(id: $id) {\n    ...DetailsInfo_deliverable\n    ...DetailsContent_deliverable\n    ...DetailsDescription_deliverable\n    ...DetailsNotes_deliverable\n    ...DetailsSolicitations_deliverable\n    ...DetailsMainSection_deliverable\n    id\n  }\n  deliverableStateTypes: __type(name: \"DeliverableState\") {\n    ...DetailsInfo_deliverableStateTypes\n  }\n  solicitationState: __type(name: \"SolicitationState\") {\n    ...DetailsSolicitations_solicitationStateTypes\n  }\n}\n\nfragment DetailsInfo_deliverable on DeliverableNode {\n  state\n  title\n  jobId\n  contractSignDeadline\n  release {\n    id\n    name\n    code\n    product {\n      id\n      title\n    }\n  }\n  job {\n    id\n    name\n  }\n}\n\nfragment DetailsContent_deliverable on DeliverableNode {\n  id\n  title\n  description\n  state\n  internalId\n  release {\n    id\n    name\n  }\n  category {\n    id\n    name\n    categoryTypes {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n  categoryType {\n    id\n    name\n  }\n  amount\n  currencyCode\n  assignedStaff {\n    id\n    fullName\n    user {\n      id\n    }\n  }\n  assignedContractor {\n    fullName\n    id\n  }\n  assignedInternally {\n    fullName\n    id\n  }\n  tags {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  dueDate\n  managerNote\n}\n\nfragment DetailsDescription_deliverable on DeliverableNode {\n  description\n  state\n}\n\nfragment DetailsNotes_deliverable on DeliverableNode {\n  managerNote\n}\n\nfragment DetailsSolicitations_deliverable on DeliverableNode {\n  solicitations {\n    edges {\n      node {\n        id\n        staffCoordinator {\n          representativeImageUrl\n          fullName\n          id\n        }\n        dateSent\n        state\n        subject\n      }\n    }\n  }\n}\n\nfragment DetailsMainSection_deliverable on DeliverableNode {\n  id\n  dueDate\n  internalId\n  state\n  category {\n    id\n    name\n  }\n  categoryType {\n    id\n    name\n  }\n  amount\n  currencyCode\n  amountInHomeCurrency\n  assignedStaff {\n    fullName\n    representativeImageUrl\n    id\n  }\n  assignedInternally {\n    fullName\n    representativeImageUrl\n    id\n  }\n  assignedContractor {\n    id\n    fullName\n    representativeImageUrl\n  }\n}\n\nfragment DetailsInfo_deliverableStateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n\nfragment DetailsSolicitations_solicitationStateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f4956b8e9b11fd0ff019dd7089987ef6';
module.exports = node;
